module.exports = __webpack_public_path__ + "static/media/brush-alt.d5cfa837.svg";